<template>
  <div v-if="dataList!=null">
    <van-radio-group v-model="payPackageRadio">
      <van-cell-group>
        <van-cell
          v-for="(item,index) in dataList"
          :key="index"
          clickable
          @click="selectPack(item.Id)"
        >
          <van-radio slot="right-icon" :name="item.Id" />
          <template slot="title">
            <div class="payPackage-list">
              <div class="name">
                <span style="text-decoration:line-through">￥{{item.Pricle}}</span>
                <br />
                <span style="color: orange;">￥{{item.SellPricle}}</span>
              </div>

              <div class="bd">
                <img src="@/assets/images/me/gold.png" />
                <p class="num">{{item.Pricle*100}}孝爱币</p>
              </div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>

    <van-radio-group v-model="payStyleRadio">
      <van-cell-group title="请选择支付方式">
        <van-cell clickable @click="payStyleRadio = '1'">
          <van-radio slot="right-icon" name="1" />
          <template slot="title">
            <div class="paystyle-list">
              <img src="@/assets/images/me/ic_pay_wechat.png" />
              <div class="flexmid">
                <p class="tit">微信支付</p>
              </div>
            </div>
          </template>
        </van-cell>
        <!-- <van-cell clickable @click="payStyleRadio = '2'">
          <van-radio slot="right-icon" name="2" />
          <template slot="title">
            <div class="paystyle-list">
              <img src="@/assets/images/me/ic_pay_alipay.png" />
              <div class="flexmid">
                <p class="tit">支付宝支付</p>
              </div>
            </div>
          </template>
        </van-cell>-->
      </van-cell-group>
    </van-radio-group>
    <div class="btn-area">
      <van-button @click="onPay" class="mybtn" type="info" size="large">确认支付</van-button>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { Toast } from "vant";
export default {
  data() {
    return {
      payStyleRadio: "1",
      payPackageRadio: 0,
      options: {
        type: "WeiXinPay"
      },
      dataList: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var that = this;
      var _options = {
        type: "GetRechargePricleList"
      };

      that.$store.dispatch(_options).then(
        res => {
          //console.log(res);
          that.dataList = res;
          if (that.dataList != null && that.dataList.length > 0) {
            that.payPackageRadio = that.dataList[0].Id;
            console.log(that.payPackageRadio);
          }
        },
        error => {}
      );
    },
    selectPack(id) {
      this.payPackageRadio = id;
    },
    onPay() {
      var that = this;
      var _openId = sessionStorage.getItem("OpenId");
      console.log("使用微信支付");
      Object.assign(that.options, {
        rechargeId: that.payPackageRadio,
        openid: _openId
      });
      that.$store.dispatch(that.options).then(
        res => {
          console.log(res);
          that.$weixin.weiXinPay(res,function(){
            that.$router.go(-1);
          },function(){

          });
        },
        error => {}
      );
    },
    getMember() {
      var _options = {
        type: "GetMemberIndex"
      };
      this.$store.dispatch(_options);
    }
  }
};
</script>

<style scoped>
.form-setion {
  margin: 20px 0 20px;
}

.paystyle-list {
  display: flex;
  align-items: center;
}
.paystyle-list img {
  width: 32px;
  height: 32px;
  margin-right: 15px;
}
.paystyle-list .tit {
  font-size: 15px;
}
.paystyle-list .des {
  font-size: 12px;
  color: #999;
}
.paystyle-list .payDisableIcon {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: auto;
  margin: 0;
}
.payPackage-list {
  display: flex;
  align-items: center;
}
.payPackage-list > .name {
  font-size: 14px;

  flex: 1;
}
.payPackage-list > .bd {
  flex: 2;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.payPackage-list img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 10px;
}
.payPackage-list .num {
  font-size: 14px;
  color: orange;
}
</style>